import {makeAutoObservable} from "mobx";
// import AppealService from "../services/AppealService";
// import ProviderService from "../services/ProviderService";
// import { socket } from "../socket";
// import BillingService from "../services/BillingService";
// import ProviderService from "../services/ProviderService";

class PaymentsStore {
    // {
    //     "account_id": params.accountId,
    //     "user_id": params.userId,
    //     "payment_incurrency": Number(payment),
    //     "currency_id": selectCurrencies,
    //     "actual_date": Date.now() / 1000,
    //     // "payment_enter_date": 123,
    //     "burn_time": 0,
    //     "method": selectPaymentMethod,
    //     "admin_comment": commentAdmin,
    //     "comment": commentUser,
    //     "payment_ext_number": "",
    //     "payment_to_invoice": 0,
    //     "turn_on_inet": 1
    // }

    isLoading = false;
    payments = {};

    constructor() {
        makeAutoObservable(this)
        this.isLoading = true
    }

    setPayments(providerId, payments) {
        this.payments[providerId] = payments;
    }

    getPayments(providerId) {
        if (providerId in this.payments) {
            return this.payments[providerId]
        }
        else {
            this.payments[providerId] = [];
            return [] 
        }
        // return this.payments
    }
}

export default new PaymentsStore()